// export const getUserEmailFromToken = (token: string) => {
// 	const base64Url = token.split('.')[1];
// 	const base64 = base64Url.replace('-', '+').replace('_', '/');
// 	const decodedToken = JSON.parse(atob(base64));

// 	return decodedToken.email;
// };
export const getUserEmailFromToken = (token: string | null) => {
	if (!token) return null;

	try {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const decodedToken = JSON.parse(atob(base64));

		return decodedToken.email;
	} catch (error) {
		console.error('Failed to decode token:', error);
		return null;
	}
};
